import React from 'react';
import { FormattedMessage } from 'react-intl';

// UI-Components
import { NotificationService } from 'ui-components/services/notification-service';
import { ModalService } from 'ui-components/services/modal-service';

// Store
import Global from '../../../store/global-selectors';
import * as JobPipelineActions from '../../../store/job-pipeline/job-pipeline.actions';

import { messages } from '../messages';

export const ShowRequestingNotificationStep = (state, jobId) => {
  const jobData = Global.selectJobPipelineJobDataByJobId(state, { jobId });
  const { modalId } = jobData;
  ModalService.closeModalById(modalId, false);
  const notificationId = NotificationService.showNotification({
    type: 'info',
    title: <FormattedMessage {...messages.requestingTitle} />,
    content: <FormattedMessage {...messages.requestingContent} />,
    progress: true,
    dontHide: true,
  });

  return [JobPipelineActions.updateJob(jobId, { notificationId, modalId: undefined }), JobPipelineActions.goForwardOnJob(jobId)];
};
